import { combineReducers } from "redux";
// import { persistReducer } from 'redux-persist';
import storage from "redux-persist/lib/storage";
// slices
import authReducer from "./slices/auth/authSlice";
import bioLinkReducer from "./slices/bioLink/bioLinkSlice";
import gettingBioLinkReducer from "./slices/getLink/getLinkSlice";
import blocksliceReducer from "./slices/block/createBlockSlice";
import linkBlockReducer from "./slices/block/createBioLinkButtonSlice";
import youtubeBlockReducer from "./slices/block/createYoutubeBlockSlice";
import faqBlockReducer from "./slices/block/createFaqBlockSlice";
import tikTokBlockReducer from "./slices/block/createTikTokBlock";
import socialBlockReducer from "./slices/block/createSocialBlock";
import changeStatusReducer from "./slices/block/changeStatusBlockSlice";
import deleteBlockReducer from "./slices/block/deleteBlockSlice";
import linkListReducer from "./slices/gettingLinksList/gettingLinkListSlice";
import cardReducer from "./slices/cards/cardSlice";
import settingFieldReducer from "./slices/settingField/settingFieldSlice";
import mainScreanReducer from "./slices/linkPreview/linkPreviewSlice";
import paymentStripesReducer from "./slices/paymentStripes/paymentStripesSlice";
import ImageGridReducer from "./slices/imageGrid/ImageGridSlice";
import taxesReducer from "./slices/taxes/taxesSlice";
// import seoSettingsReducer from './slices/seo-settings/seoSettingsSlice';
import codesRecucer from "./slices/codes/codesSlices";
import userReducer from "./slices/user/userSlice";
import qrcodesReducer from "./slices/block/createShareSlice";
import fontSettingReducer from "./slices/appearance/createFontSettingsSlice";
import brandingSettingsReducer from "./slices/appearance/createBrandingSettingSlice";
import favSettingsReducer from "./slices/appearance/createFavSettingsSlice";
import seoSettingsReducer from "./slices/appearance/createSeoSettingSlice";
import backgroundSettingsReducer from "./slices/appearance/createBackgroundSettingsSlice";
import avatarSettingsReducer from "./slices/appearance/createAvatarSettingsSlice";
import linkSettingsReducer from "./slices/appearance/createLinkSettingsSlice";
import gettingAppearanceSlice from "./slices/appearance/appearanceSlice";
import InvitationSlice from "./slices/InvitationSystem/InvitationSlice";
import LanguagesSlice from "./slices/Languages/LanguagesSlice";
import themeSlice from "./slices/darkThemeSlice/themSlice";
import locationReducer from "./slices/location/locationSlice";

// ----------------------------------------------------------------------
const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: ["invitationListEmails", "language"],
};

const appReducer = combineReducers({
  user: authReducer,
  bioLinkCreated: bioLinkReducer,
  gettingBioLinksState: gettingBioLinkReducer,
  blockHeading: blocksliceReducer, //  reducer for all modal in Cretae block
  linkBlock: linkBlockReducer,
  youtubeBlock: youtubeBlockReducer,
  faqBlock: faqBlockReducer,
  tikTokBlock: tikTokBlockReducer,
  socialBlock: socialBlockReducer,
  changeBLock: changeStatusReducer,
  deleteBlock: deleteBlockReducer,
  linkList: linkListReducer,
  cards: cardReducer,
  settingField: settingFieldReducer,
  linkPreview: mainScreanReducer,
  paymentStripes: paymentStripesReducer,
  imageGrid: ImageGridReducer,
  taxes: taxesReducer,
  seoSettings: seoSettingsReducer,
  codes: codesRecucer,
  adminUser: userReducer,
  shareQRCode: qrcodesReducer,
  fontSetting: fontSettingReducer,
  brandingSettings: brandingSettingsReducer,
  favSettings: favSettingsReducer,
  backgroundSettings: backgroundSettingsReducer,
  avatarSettings: avatarSettingsReducer,
  linkSettings: linkSettingsReducer,
  gettingAppearance: gettingAppearanceSlice,
  invitationListEmails: InvitationSlice,
  language: LanguagesSlice,
  theme: themeSlice,
  location: locationReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "logoutUser") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// const rootReducer = combineReducers({
//   user: authReducer,
//   bioLinkCreated: bioLinkReducer,
//   gettingBioLinksState: gettingBioLinkReducer,
//   blockHeading: blocksliceReducer, //  reducer for all modal in Cretae block
//   linkBlock: linkBlockReducer,
//   youtubeBlock: youtubeBlockReducer,
//   faqBlock: faqBlockReducer,
//   tikTokBlock: tikTokBlockReducer,
//   socialBlock: socialBlockReducer,
//   changeBLock: changeStatusReducer,
//   deleteBlock: deleteBlockReducer,
//   linkList: linkListReducer,
//   cards: cardReducer,
//   settingField: settingFieldReducer,
//   linkPreview: mainScreanReducer,
//   paymentStripes: paymentStripesReducer,
//   imageGrid: ImageGridReducer,
//   taxes: taxesReducer,
//   seoSettings: seoSettingsReducer,
//   codes: codesRecucer,
//   adminUser: userReducer,
//   shareQRCode: qrcodesReducer,
//   fontSetting: fontSettingReducer,
//   brandingSettings: brandingSettingsReducer,
//   favSettings: favSettingsReducer,
//   backgroundSettings: backgroundSettingsReducer,
//   avatarSettings: avatarSettingsReducer,
//   linkSettings: linkSettingsReducer,
//   gettingAppearance: gettingAppearanceSlice
// });
export { rootPersistConfig, rootReducer };
